import styled from 'styled-components';
import { IconButton } from '@/components/IconButton/IconButton';
import { CardWrapper } from '@/components/Card/styles';
import { COLORS } from '@/styles/colors';

export const SortingButtonWrapper = styled(IconButton)`
  width: 50px;
  height: 50px;
  border: 1px solid ${COLORS.grey[400]};
`;

export const ListCardWrapper = styled(CardWrapper)``;
